import invariant from 'invariant';

export default {
  callbacks: [],

  appended: false,

  load(params, callback) {
    const index = this.callbacks.push(callback);
    if (window.google) {
      setTimeout(this.fireCallbacks.bind(this));
    } else {
      if (!this.appended) {
        window.mapsCallback = this.mapsCallback.bind(this);
        this.appendScript(params);
      }
    }
    return index;
  },

  getSrc(opts) {
    invariant(opts.hasOwnProperty('apiKey'), 'You must pass an apiKey to use GoogleApi');

    const apiKey = opts.apiKey;
    const client = opts.client;
    const libraries = opts.libraries || ['places'];
    const googleVersion = opts.version || '3';
    const language = opts.language;
    const channel = opts.channel || null;
    const region = opts.region || null;
    const callback = opts.callback || 'mapsCallback';
    const URL = 'https://maps.googleapis.com/maps/api/js';

    const url = () => {
      let url = URL;
      let params = {
        key: apiKey,
        callback,
        libraries: libraries.join(','),
        client,
        v: googleVersion,
        channel,
        language,
        region,
      };

      let paramStr = Object.keys(params)
        .filter((k) => !!params[k])
        .map((k) => `${k}=${params[k]}`)
        .join('&');

      return `${url}?${paramStr}`;
    };

    return url();
  },

  appendScript(params) {
    const src = this.getSrc(params);
    const script = document.createElement('script');
    script.setAttribute('src', src);
    document.head.appendChild(script);
    this.appended = true;
  },

  mapsCallback() {
    window.mapsCallback = undefined;
    this.fireCallbacks();
  },

  fireCallbacks() {
    this.callbacks.forEach((callback) => callback());
    this.callbacks = [];
  },

  removeCallback(index) {
    this.callbacks.splice(index - 1, 1);
  },
};
